import { Injectable } from '@angular/core';
import { INotesTypeEntityDTO } from '@modeso/types__aumico-lib-notes-be';
import { INotesTypesWithSingleLanguage } from '../interfaces/INotesTypesWithSingleLanguage.interface';

@Injectable({
    providedIn: 'root',
})
export class NotesTypesMapper {
    constructor() {}

    getNotesTypesWithLanguage(notesTypes: INotesTypeEntityDTO[], language: string): INotesTypesWithSingleLanguage[] {
        const notesTypesWithSingleLanguage: INotesTypesWithSingleLanguage[] = [];

        notesTypes.forEach((notesType: INotesTypeEntityDTO) => {
            const notesTypeWithSingleLanguage: INotesTypesWithSingleLanguage = {
                _id: notesType._id,
                name: notesType.name,
                title: notesType.title[language],
                componentsOptions: notesType.componentsOptions,
                owner: notesType.owner,
            };

            notesTypesWithSingleLanguage.push(notesTypeWithSingleLanguage);
        });

        return notesTypesWithSingleLanguage;
    }
}
